import React, { useState, Fragment } from "react";
import {
    Button,
    TableCell,
    Box,
    TableRow,
    Stack,
    IconButton,
    Tooltip,
    Chip,
} from "@mui/material";
import CreateIcon from '@mui/icons-material/Create';

import { useNavigate } from "react-router-dom";
import qs from 'qs';

import PageTitle from "../../../hooks/page-title";
import API from "../../../axios";
import {
    SelectBox,
    InputField,
    SearchComboBox,
    AddProjectBtn,
    CustomModal,
    UsePagination,
    TableWrapper,
    OrderDataBtn,
    MultiSelect,
    InfoHeading,
    FilterWrapper
} from "../../../components";

import ComponentForm from "./comp-form";
import { icon1, icon2, icon3 } from "../../../assets";
import { generateKey } from "../../../helpers/generate-key";
import ComponentLayout from "./component-layout";
import { useSelector } from "react-redux";
import myTranslator from "../../../helpers/myTranslator";


export default function ComponentsPanel() {
    PageTitle('Components');
    const { selectedLang, translation } = useSelector((state) => state.storeReducer); 
    const [createCompModal, setCreateCompModal] = useState(false);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState(null);
    // filter states
    const [perPage, setPerPage] = useState(25);
    const [search, setSearch] = useState('');
    const [compType, setCompType] = useState('');
    const [status, setStatus] = useState('');
    const [language, setLanguage] = useState("");
    const [technologies, setTechnologies] = useState("");
    const [orderBy, setOrderBy] = useState({
        name: 'created_at',
        order: 'desc'
    });
    const [updateKey, setUpdateKey] = useState(generateKey());
    const [columns, setColumns] = useState(_columns);
    const [toggler, setToggler] = useState(false);
    const [IsFilterApply, setIsFilterApply] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, orderBy, perPage]);

    const closeModal = () => setCreateCompModal(false);

    const applyFilters = () => {
        setIsFilterApply(true);
        getData();
    }

    const clearFilters = () => {
        setIsFilterApply(false);
        if (search !== '') {
            setSearch('');
        }
        if (compType !== '') {
            setCompType('');
        }
        if (status !== '') {
            setStatus('');
        }
        if (language !== "") {
            setLanguage("");
        }
        if (technologies !== "") {
            setTechnologies("");
        }
        if (orderBy.name !== 'name' && orderBy.order !== 'asc') {
            setOrderBy({
                name: 'created_at',
                order: 'desc',
            });
        }
        setUpdateKey(generateKey());
        getData();
    }

    const getData = async () => {
        setIsLoading(true);
        try {
            const params = {
                page: page,
                per_page: perPage,
                search: search,
                componenttype: compType?.title ?? '',
                active: status === 'active' ? 1 : 0,
                inactive: status === 'disable' ? 1 : 0,
                battery_storage: technologies === 'battery_storage' ? 1 : 0,
                energy_management: technologies === 'energy_management' ? 1 : 0,
                photovoltaic: technologies === 'photovoltaic' ? 1 : 0,
                column: orderBy.name,
                orderby: orderBy.order,
            }
            let { data } = await API('admin/components?' + qs.stringify(params), 'get');
            setRecords(data);
            setIsLoading(false);
        } catch (error) {
            if (!!records) setRecords(null);
            setIsLoading(false);
        }
    }

    const myFilters = () => {
        return (
            <>
                <InputField
                    size="small"
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_search")}
                    fullWidth
                    handleChange={(e) => setSearch(e.target.value)}
                    initValue={search}
                />
                <SearchComboBox
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_comp_type")}
                    fullWidth
                    url={`admin/component-types?active=1&`}
                    objLabel='title'
                    required
                    size='small'
                    handleChange={(item) => setCompType(item)}
                    key={updateKey}
                />
                <SelectBox
                    items={techOptions}
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_technologies")}
                    size="small"
                    fullWidth
                    initValue={technologies}
                    handleChange={(e) => setTechnologies(e.target.value)}
                />
                <SelectBox
                    items={langOptions}
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_language")}
                    size="small"
                    fullWidth
                    initValue={language}
                    handleChange={(e) => setLanguage(e.target.value)}
                />
                <SelectBox items={[
                    { label: 'Active', value: 'active' },
                    { label: 'Disabled', value: 'disable' }
                ]}
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_status")}
                    size='small'
                    fullWidth
                    initValue={status}
                    handleChange={(e) => setStatus(e.target.value)}
                />

            </>
        );
    }

    const tableFilters = () => {
        return (
            <>
                <MultiSelect
                    columnsList={columns}
                    setColumnsList={(e) => {
                        setColumns(e);
                        setToggler(!toggler);
                    }}
                />
                <SelectBox
                    label={myTranslator(translation,selectedLang,"sa_comp_panel_label_shown")}
                    fullWidth
                    size='small'
                    items={rowsOption}
                    handleChange={(e) => setPerPage(e.target.value)}
                    initValue={perPage}
                />
            </>
        )
    }

    const printTh = () => {
        return (
            <>
                <TableCell
                    width='20px'
                >
                </TableCell>
                {columns.map((v, i) => {
                    if (!v.show) return <></>
                    return (<Fragment key={i}>
                        {v.type === 'simple_label' &&
                            <TableCell>
                                {myTranslator(translation,selectedLang,v.label)}
                            </TableCell>
                        }
                        {v.type === 'order_label' &&
                            <TableCell>
                                <OrderDataBtn handleBtn={setOrderBy} selected={orderBy.name} value={v.value} title={myTranslator(translation,selectedLang,v.label)} />
                            </TableCell>
                        }
                    </Fragment>);
                })}
            </>
        );
    }

    return (
        <ComponentLayout>
            <Box>
                <FilterWrapper
                    isApplied={IsFilterApply}
                    filters={myFilters()}
                    btn={(search || compType || technologies || language || status) !== '' &&
                        <Button
                            variant="contained"
                            sx={{ borderRadius: "25px", textTransform: "none", width: { md: "fit-content", xs: "100%" } }}
                            onClick={applyFilters}
                        >
                            {myTranslator(translation,selectedLang,"sa_comp_panel_btn_filter")}
                        </Button>
                    }
                    tableFilters={tableFilters()}
                    clearFilters={clearFilters}
                />
                <Box>
                    {records?.last_page > 1 && (
                        <Box component="div" mb={3} mt={2}>
                            <UsePagination
                                total={records?.total}
                                perPage={records?.per_page}
                                page={records?.current_page}
                                setPage={setPage}
                                key={records?.last_page}
                            />
                        </Box>
                    )}
                    <TableWrapper
                        thContent={printTh()}
                        spanTd='10'
                        tableStyle={{ minWidth: '1200px' }}
                        isLoading={isLoading}
                        isContent={records?.data.length}
                    >
                        {records?.data.map((v, i) => {
                            let rowNum = (records?.current_page - 1) * records?.per_page + i + 1;
                            return (
                                <TableRow key={i}>
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        {rowNum}
                                    </TableCell>
                                    {columns[0]?.show &&
                                        <TableCell>
                                            {v.componenttypes.title}
                                        </TableCell>
                                    }
                                    {columns[1]?.show &&
                                        <TableCell>
                                            <Box>
                                                {v.active ?
                                                    (v.name || '-')
                                                    :
                                                    <InfoHeading
                                                        color='error'
                                                        iconColor='error'
                                                        iconSize='20px'
                                                        infoText={myTranslator(translation,selectedLang,"sa_comp_panel_info_txt")}
                                                        text={v.name} />
                                                }
                                            </Box>
                                        </TableCell>
                                    }
                                    {columns[2]?.show &&
                                        <TableCell>
                                            {v.item_number ?? '-'}
                                        </TableCell>
                                    }
                                    {columns[3]?.show &&
                                        <TableCell>
                                            -
                                        </TableCell>
                                    }
                                    {columns[4]?.show &&
                                        <TableCell>
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                            >
                                                {v?.photovoltaic &&
                                                    <Tooltip title={myTranslator(translation,selectedLang,"sa_comp_panel_tooltip_photovoltaic")} placement="top">
                                                        <div className="cube">
                                                            <img src={icon1} alt='' />
                                                        </div>
                                                    </Tooltip>
                                                }
                                                {v?.battery_storage &&
                                                    <Tooltip title={myTranslator(translation,selectedLang,"sa_comp_panel_tooltip_battery_storage")} placement="top">
                                                        <div className="cube">
                                                            <img src={icon2} alt='' />
                                                        </div>
                                                    </Tooltip>
                                                }
                                                {v?.energy_management &&
                                                    <Tooltip title={myTranslator(translation,selectedLang,"sa_comp_panel_tooltip_energy_management")} placement="top">
                                                        <div className="cube">
                                                            <img src={icon3} alt='' />
                                                        </div>
                                                    </Tooltip>
                                                }
                                            </Stack>
                                        </TableCell>
                                    }
                                    {columns[5]?.show &&
                                        <TableCell>
                                            -
                                        </TableCell>
                                    }
                                    {columns[6]?.show &&
                                        <TableCell>
                                            {v.active ? 'Active' : <Chip label='Disabled' size='small' />}
                                        </TableCell>
                                    }
                                    {columns[7]?.show &&
                                        <TableCell>
                                            -
                                        </TableCell>
                                    }
                                    {columns[8]?.show &&
                                        <TableCell>
                                            <Tooltip title={myTranslator(translation,selectedLang,"sa_comp_panel_tooltip_edit")} placement='top'>
                                                <IconButton
                                                    onClick={() => navigate(`/admin/components/${v.id}`, { id: v.id })}
                                                    color='info'
                                                >
                                                    <CreateIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    }
                                </TableRow>)
                        })}
                    </TableWrapper>
                    {records?.last_page > 1 && (
                        <Box component="div" sx={{ mt: 4 }}>
                            <UsePagination
                                total={records?.total}
                                perPage={records?.per_page}
                                page={records?.current_page}
                                setPage={setPage}
                                key={records?.last_page}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
            {createCompModal ?
                <CustomModal width='850px' children={<ComponentForm handleClose={closeModal} />} handleClose={closeModal} />
                :
                <AddProjectBtn
                    tooltip={myTranslator(translation,selectedLang,"sa_comp_panel_tooltip_create_component")}
                    handleClick={() => setCreateCompModal(true)} />
            }
        </ComponentLayout>
    )
}

const rowsOption = [
    { label: '25 Rows', value: '25' },
    { label: '50 Rows', value: '50' },
    { label: '75 Rows', value: '75' },
    { label: '100 Rows', value: '100' },
];

const langOptions = [
    { label: 'Deutsch (CH)', value: 'dutch' },
    { label: 'English', value: 'english' }
];

const techOptions = [
    { label: 'Battery Storage', value: 'battery_storage' },
    { label: 'Energy Management', value: 'energy_management' },
    { label: 'Photovoltaic', value: 'photovoltaic' }
];

const _columns = [
    {
        id: 1,
        label: 'sa_comp_panel_label_component_type',
        value: 'component_type',
        show: true,
        type: 'simple_label'
    },
    {
        id: 2,
        label: 'sa_comp_panel_label_name',
        value: 'name',
        show: true,
        type: 'order_label'
    },
    {
        id: 3,
        label: 'sa_comp_panel_label_item_number',
        value: 'item_number',
        show: true,
        type: 'order_label'
    },
    {
        id: 4,
        label: 'sa_comp_panel_label_unit',
        value: 'fourth_col',
        show: true,
        type: 'simple_label'
    },
    {
        id: 5,
        label: 'sa_comp_panel_label_techno',
        value: 'fifth_col',
        show: true,
        type: 'simple_label'
    },
    {
        id: 6,
        label: 'sa_comp_panel_label_language',
        value: 'sixth_col',
        show: true,
        type: 'simple_label'
    },
    {
        id: 7,
        label: 'sa_comp_panel_label_status',
        value: 'seventh_col',
        show: true,
        type: 'simple_label'
    },
    {
        id: 8,
        label: 'sa_comp_panel_label_tags',
        value: 'eight_col',
        show: true,
        type: 'simple_label'
    },
    {
        id: 9,
        label: 'sa_comp_panel_label_action',
        value: 'nine_col',
        show: true,
        type: 'simple_label'
    },
];